import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialShareModalComponent } from './social-share-modal.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';

@NgModule({
  declarations: [SocialShareModalComponent],
  imports: [CommonModule, FGBSharedModule, DirectivesModule],
  exports: [SocialShareModalComponent],
})
export class SocialShareModalModule {}
